export default __webpack_public_path__ + "static/media/won.2e73fbca.mp3";